/**
 * Decodes a base64 file payload (as returned by DownloadFileResponse from the API)
 * and triggers a browser download. Works for binary files (e.g. installers), not just text.
 */
export const downloadBase64File = (base64Content: string, fileName: string, mimeType = 'application/octet-stream') => {
	const byteCharacters = atob(base64Content)
	const byteNumbers = new Array(byteCharacters.length)
	for (let i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i)
	}
	const byteArray = new Uint8Array(byteNumbers)
	const blob = new Blob([byteArray], { type: mimeType })

	const url = URL.createObjectURL(blob)
	const a = document.createElement('a')
	a.href = url
	a.download = fileName
	a.click()
	URL.revokeObjectURL(url)
}
